export const messages = {
  en: {
    allocationStorehouseManage: {
      search: {
        title: 'Search Conditions',
        startUserName: 'Please enter applicant name',
        applyType: 'Please select type',
        startTime: 'Please select allocation start time',
        endTime: 'Please select allocation end time'
      },
      list: {
        title: 'Allocation Records',
        allocation: 'Allocation'
      },
      table: {
        applyId: 'No.',
        applyCount: 'Allocation/Return',
        startUserName: 'Applicant',
        stateName: 'Status',
        applyTypeName: 'Type',
        createTime: 'Time'
      },
      operation: {
        cancel: 'Cancel Allocation',
        detail: 'Detail',
        flowChart: 'Flow Chart'
      }
    },
    allocationStorehouse: {
      title: 'Apply Allocation',
      sourceWarehouse: 'Source Warehouse',
      targetWarehouse: 'Target Warehouse',
      itemName: 'Item Name',
      stock: 'Stock',
      allocationCount: 'Allocation Count',
      remark: 'Remark',
      requiredSourceWarehouse: 'Required, please select source warehouse',
      requiredTargetWarehouse: 'Required, please select target warehouse',
      requiredItemName: 'Required, please enter item name',
      requiredStock: 'Required, please enter stock',
      requiredAllocationCount: 'Required, please enter allocation count',
      requiredRemark: 'Required, please enter remark',
      positiveNumber: 'Must be positive integer',
      remarkTooLong: 'Remark is too long'
    },
    deleteStorehouseManage: {
      title: 'Please confirm your operation',
      confirmCancel: 'Confirm to cancel allocation?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      deleteError: 'Failed to cancel allocation'
    }
  },
  zh: {
    allocationStorehouseManage: {
      search: {
        title: '查询条件',
        startUserName: '请输入申请人姓名',
        applyType: '请选择类型',
        startTime: '请选择调拨开始时间',
        endTime: '请选择调拨结束时间'
      },
      list: {
        title: '调拨记录',
        allocation: '调拨'
      },
      table: {
        applyId: '编号',
        applyCount: '调拨/退还',
        startUserName: '申请人',
        stateName: '状态',
        applyTypeName: '类型',
        createTime: '时间'
      },
      operation: {
        cancel: '取消调拨',
        detail: '详情',
        flowChart: '流程图'
      }
    },
    allocationStorehouse: {
      title: '申请调拨',
      sourceWarehouse: '源仓库',
      targetWarehouse: '目标仓库',
      itemName: '物品名称',
      stock: '库存',
      allocationCount: '调拨数量',
      remark: '备注',
      requiredSourceWarehouse: '必填，请选择源仓库',
      requiredTargetWarehouse: '必填，请选择目标仓库',
      requiredItemName: '必填，请填写物品名称',
      requiredStock: '必填，请填写库存',
      requiredAllocationCount: '必填，请填写调拨数量',
      requiredRemark: '必填，请填写备注',
      positiveNumber: '必须为正整数',
      remarkTooLong: '备注太长'
    },
    deleteStorehouseManage: {
      title: '请确认您的操作',
      confirmCancel: '确定取消调拨？',
      cancel: '点错了',
      confirm: '确认取消',
deleteError: '取消调拨失败'
    }
  },
  'zh-TW': {
    allocationStorehouseManage: {
      search: {
        title: '查詢條件',
        startUserName: '請輸入申請人姓名',
        applyType: '請選擇類型',
        startTime: '請選擇調撥開始時間',
        endTime: '請選擇調撥結束時間'
      },
      list: {
        title: '調撥記錄',
        allocation: '調撥'
      },
      table: {
        applyId: '編號',
        applyCount: '調撥/退還',
        startUserName: '申請人',
        stateName: '狀態',
        applyTypeName: '類型',
        createTime: '時間'
      },
      operation: {
        cancel: '取消調撥',
        detail: '詳情',
        flowChart: '流程圖'
      }
    },
    allocationStorehouse: {
      title: '申請調撥',
      sourceWarehouse: '源倉庫',
      targetWarehouse: '目標倉庫',
      itemName: '物品名稱',
      stock: '庫存',
      allocationCount: '調撥數量',
      remark: '備註',
      requiredSourceWarehouse: '必填，請選擇源倉庫',
      requiredTargetWarehouse: '必填，請選擇目標倉庫',
      requiredItemName: '必填，請填寫物品名稱',
      requiredStock: '必填，請填寫庫存',
      requiredAllocationCount: '必填，請填寫調撥數量',
      requiredRemark: '必填，請填寫備註',
      positiveNumber: '必須為正整數',
      remarkTooLong: '備註太長'
    },
    deleteStorehouseManage: {
      title: '請確認您的操作',
      confirmCancel: '確定取消調撥？',
      cancel: '點錯了',
      confirm: '確認取消',
      deleteError: '取消調撥失敗'
    }
  }
}